import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import axios from "axios";
import { Alert, Button, Container } from "react-bootstrap";
import api from "utils/axiosInstance";
import formatMinutes from "utils/formatMinutes";
import MUIDataTable from "mui-datatables";
import { UserTrackingDetails } from "./UserTrackingDetails";

const TABLE_HEADERS = [
  {
    name: "userId",
    label: "UserID",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "randomization",
    label: "Study Group",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "weekNumbers",
    label: "Week Numbers",
    options: {
      filter: true,
    },
  },
  {
    name: "datesIncluded",
    label: "Login Dates",
    options: {
      filter: true,
      sort: true,
    },
  },

  {
    name: "timeSpent",
    label: "Total Time Spent",
    options: {
      filter: true,
      sort: true,
    },
  },
];

const UserTrackingSummary = ({ setUser }) => {
  const [timeSpentData, setTimeSpentData] = useState([]);
  const [error, setError] = useState({ state: false, message: "" });
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    (async function () {
      const timeSpentDataResponse = await getTimespentData();
      setTimeSpentData(
        timeSpentDataResponse.map((data, index) => ({
          id: index,
          ...data,
          weekNumbers: data.weekNumbers.sort().join(", "),
          randomization:
            data.randomization === 2
              ? "HRVB"
              : data.randomization === 1
              ? "EDU"
              : "Unknown",
          timeSpent: formatMinutes(data.totalTimeSpent),
        }))
      );
    })();
  }, []);

  async function getTimespentData() {
    try {
      const timeSpentRes = await api({ method: "get", url: "/User/tracking" });
      return timeSpentRes.data;
    } catch (err) {
      if (err.response && err.response.data) {
        setError({
          state: true,
          message:
            (err.response && err.response.data.message) ||
            "An Unknown error occured",
        });
      }
    }
  }

  async function exportHandler() {
    if (timeSpentData.length === 0) return;

    const headers = Object.keys(timeSpentData[0]).join(",");

    const rows = timeSpentData.map((row) =>
      Object.values(row)
        .map((value) => `"${value}"`)
        .join(",")
    );

    const csvContent = [headers, ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `UserTrackingSummary - ${new Date().toLocaleDateString("en-US")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const CustomToolbarSelect = ({ selectedRows, data, columns, ...rest }) => {
    return (
      <div className="d-flex">
        <Button onClick={exportHandler}>Export Summary</Button>
      </div>
    );
  };

  const options = {
    filterType: "checkbox",
    download: false,
    customToolbarSelect: (selectedRows, data, columns) => (
      <CustomToolbarSelect
        selectedRows={selectedRows}
        data={data}
        columns={columns}
      />
    ),
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <UserTrackingDetails userId={rowData[0]} />;
    },
    onRowsSelect: (currentRowSelected, allRowsSelected) => {
      setSelectedRows(allRowsSelected.map((row) => timeSpentData[row.index]));
    },
  };

  return (
    <MUIDataTable
      title={"Time Tracking"}
      data={timeSpentData}
      columns={TABLE_HEADERS}
      options={options}
    />
  );
};

export default UserTrackingSummary;
